<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click="onClickEvent()"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import AddButtonMixins from '@/mixins/AddButton'

  export default {
    mixins: [ AddButtonMixins ],
    inject: ['onClickDate'],
    methods: {
      onClickEvent () {
        this.onClickDate(this.moment().add(1, 'month').add(1, 'day').format('YYYY-MM-DD'))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddScheduledCaseButton.vue?7c1d58cf